module.exports = __webpack_public_path__ + "media/images/map_icons/Running-7613c104adf1950c6004bc76d9627d88.svg";